import { useTranslation } from 'react-i18next';
import HierarchySubmitButton from '../HierarchySubmitButton/HierarchySubmitButton';

interface HierarchyXLSXSubmitButtonProps {
	onClick: () => void;
	disabled: boolean;
	loading?: boolean;
}
const HierarchyXLSXSubmitButton = ({
	onClick,
	disabled,
	loading
}: HierarchyXLSXSubmitButtonProps) => {
	const { t } = useTranslation();
	return (
		<HierarchySubmitButton onClick={onClick} disabled={disabled} loading={loading}>
			{t('groupsHierarchy.importHierarchy')}
		</HierarchySubmitButton>
	);
};

export default HierarchyXLSXSubmitButton;
